// stop isFetching and isError keys from being persisted
import localforage from "localforage";
import { createTransform } from "redux-persist";

const blacklistTransform = createTransform((inboundState, key) => {
  const newInboundState = { ...inboundState };
  delete newInboundState.isFetching;
  delete newInboundState.isError;
  delete newInboundState.authentication?.isFetching;
  delete newInboundState.authentication?.isError;
  delete newInboundState.authentication?.isNLISFetching;
  delete newInboundState.connectedDeviceId;
  delete newInboundState.availableDevices;
  delete newInboundState.isHubConnected;
  delete newInboundState.context;
  delete newInboundState.allSalesLoaded;

  if (key === "modals") {
    // Modal context can carry a live aggrid ref. This is an imperative grid
    // API object, not plain data. IndexedDB cannot store it. Strip it from
    // every modal type before it reaches persistence.
    // Copy each entry before changing it. inboundState is still the live
    // redux state. Mutating a nested object here would change the real
    // store too.
    Object.entries(newInboundState).forEach(([modalType, modalContext]) => {
      if (
        modalContext &&
        typeof modalContext === "object" &&
        "aggridRef" in modalContext
      ) {
        const { aggridRef, ...rest } = modalContext;
        newInboundState[modalType] = rest;
      }
    });
  }

  return newInboundState;
});

// Configure the localforage instance to store
const reduxPersistConfig = {
  storeName: "redux_persist_data",
  description:
    "Contains the local version of the redux store to enable store and forward capabilites",
  name: "agrinous-store-forward",
};

const reduxPersistStorageInstance =
  localforage.createInstance(reduxPersistConfig);

export const persistOptions = {
  blacklist: ["screen", "synced", "confirmModal"],
  transforms: [blacklistTransform],
  serialize: false,
  storage: reduxPersistStorageInstance,
};

export function clearState() {
  reduxPersistStorageInstance.clear();
}
